import { useEffect, useState } from "react";

import { getCookieConsent, setCookieConsent } from "src/data/system/cookieClass";
import CookieConsentIkkuna from "./components/CookieConsentIkkuna";
import { useUserData } from "src/context/userContext";

export default function Keksit() {
  const [isLoading, setIsLoading] = useState(true);
  const [isCookiesAccepted, setIsCookiesAccepted] = useState(false);
  const { token, user } = useUserData();

  useEffect(() => {
    if (!user) return;
    const asynkFunc = async () => {
      const result = await getCookieConsentFromSql(user.personId);
      const isAccepted = result != null && result.length > 0 && result[0].cookieConsentTime != null;
      setIsCookiesAccepted(isAccepted);
      setIsLoading(false);
    };
    asynkFunc();
  }, [user]);

  const getCookieConsentFromSql = async (personId) => {
    const result = await getCookieConsent(personId, token);
    return result;
  };

  // eslint-disable-next-line no-unused-vars
  const acceptKlikattu = async (acceptedByScrolling) => {
    setIsCookiesAccepted(true);
    const personId = Number(user.personId);
    await setCookieConsent(personId, token);
  };

  if (isLoading || isCookiesAccepted) {
    return <></>;
  }

  return (
    <CookieConsentIkkuna onAccept={(acceptedByScrolling) => acceptKlikattu(acceptedByScrolling)} />
  );
}
